import { render, staticRenderFns } from "./BacklinkStatusRenderer.vue?vue&type=template&id=974d5cfe&scoped=true&"
import script from "./BacklinkStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./BacklinkStatusRenderer.vue?vue&type=script&lang=js&"
import style0 from "./BacklinkStatusRenderer.vue?vue&type=style&index=0&id=974d5cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974d5cfe",
  null
  
)

/* custom blocks */
import block0 from "./BacklinkStatusRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports